export default __webpack_public_path__ + "static/yt_icon-65978d72d28eed23bfa631d1397726e1.png";